import i18n from '@/libs/i18n'

export default [
  {
    path: '/login',
    name: 'auth-login-redirect',
    meta: {
      pageTitle: i18n.t('Login'),
      layout: 'full',
    },
    // Auth0 bootstrap owns the redirect (including organization invitations).
    // Keep this route so `/login?invitation=&organization=` can finish matching
    // without forwarding to a non-existent named route.
    component: {
      render(h) {
        return h('div')
      },
    },
  },
]
